import dayjs from "dayjs";
import {random} from "lodash";
import {convertIosStringToDateDayjs, randomId} from "./common";
const toDateTime = (data, format) => {
  if (!data) {
    return null;
  } else {
    return dayjs(data, format);
  }
};

const parseDatetime = (data, format) => {
  if (data === null || data === undefined || data === "") return null;
  else return data.format(format);
};

const compareDate = (val1, val2, format) => {
  if (dayjs(val1).format(format) === dayjs(val2).format(format)) return true;
  else return false;
};
const convertListContainDate = (list: any[] | [], listNameDate: string[]) => {
  return list.map(e => {
    return convertObjContainDate(e, listNameDate);
  });
};
const convertObjContainDate = (obj: any, listNameDate: string[]) => {
  let convertedObj = obj;
  listNameDate.forEach(name => {
    if (obj?.[name]) {
      convertedObj = {
        ...convertedObj,
        [name]: convertIosStringToDateDayjs(obj?.[name]),
      };
    }
  });
  return convertedObj;
};

export {
  toDateTime,
  parseDatetime,
  compareDate,
  convertListContainDate,
  convertObjContainDate,
};
